import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { queryKeys } from 'config/queryKeys'

type UseDeleteCouponsMutation = {
	ids: number[]
	onSettled: () => void
}

export const useDeleteCouponsMutation = ({ ids, onSettled }: UseDeleteCouponsMutation) => {
	const { t } = useTranslation()
	const queryClient = useQueryClient()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: couponsDeleteMutation } = useMutation({
		mutationFn: () => {
			// TODO: change to apiRoutes
			return axiosPrivate.post('/coupons/bulk_delete/', { ids })
		},
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Coupons deleted')
			})()
			queryClient.invalidateQueries({ queryKey: queryKeys.coupons.all })
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		couponsDeleteMutation
	}
}
